import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import * as moment from 'moment';
import {EvsAddressService} from '../../../../../common/services/EvsAddress.service';
import {BusinessService} from '../../../../../common/services/Business.service';

declare var $: any;
var that;

@Component({
  selector: 'app-print-guarantee',
  templateUrl: './print-guarantee.component.html',
  styleUrls: ['./print-guarantee.component.css']
})
export class PrintGuaranteeComponent implements OnInit {
  public isShowButton = true;
  public now: any = '';
  public qri: any = 'jssoasdkoasdk';
  public logs_of_serial: any = [];
  public serial_info: any = {};
  public agency_info: any = {};
  source = Number(JSON.parse(localStorage.getItem('User')).source)
  public inforBussiness: any;
  public inforBussiness_city: any;
  public inforBussiness_districts: any;
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public active_log_of_serial: any;
  public receive_log_of_serial: any = [];
  public validate_receive_log_of_serial: any;
  public addressCustomer: any;
  public addressCustomer2: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private addressService: EvsAddressService,
    private businessService: BusinessService,
  ) {
    that = this;
  }

  print() {
    this.isShowButton = false;
    $('#container').css('border', 'none');
    setTimeout(() => {
      window.print()
    }, 100)
  }

  close() {
    this.router.navigate(['/evs/guarantee/logs'])
  }

  convertDate(time?) {
    return time.split('T')[0]
  }

  ngOnInit() {
    this.getProfileBussiness();
    const user = JSON.parse(localStorage.getItem('User'));
    this.getCity(user.city_id);
    this.loadDistrictData(user.city_id, user.district_id)
    // this.inforBussiness = user;
    console.log('user', user)
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      const data_params_log = JSON.parse(params.data_logs_of_serial);
      const data_params_serial = JSON.parse(params.data_serial_infor);
      const data_params_agency = JSON.parse(params.data_agency_info);
      const data_serial_qri = JSON.parse(params.data_serial_qri);
      this.qri = 'http://qcheck.vn/' + data_serial_qri
      this.logs_of_serial = data_params_log;
      this.logs_of_serial.map((res) => {
        if (res.is_active) {
          this.active_log_of_serial = res;
          if (this.active_log_of_serial) {
            // tslint:disable-next-line:max-line-length
            this.active_log_of_serial.customer.address = this.active_log_of_serial.customer.address == null ? '' : this.active_log_of_serial.customer.address;
            if (this.active_log_of_serial.customer.address) {
              // tslint:disable-next-line:max-line-length
              this.active_log_of_serial.customer.district = this.active_log_of_serial.customer.district == null ? '' : ', ' + this.active_log_of_serial.customer.district;
            } else {
              // tslint:disable-next-line:max-line-length
              this.active_log_of_serial.customer.district = this.active_log_of_serial.customer.district == null ? '' : this.active_log_of_serial.customer.district;
            }
            if (this.active_log_of_serial.customer.district) {
              // tslint:disable-next-line:max-line-length
              this.active_log_of_serial.customer.city = this.active_log_of_serial.customer.city == null ? '' : ', ' + this.active_log_of_serial.customer.city;
            } else {
              // tslint:disable-next-line:max-line-length
              this.active_log_of_serial.customer.city = this.active_log_of_serial.customer.city == null ? '' : this.active_log_of_serial.customer.city;
            }
            // tslint:disable-next-line:max-line-length
            this.addressCustomer = this.active_log_of_serial.customer.address + this.active_log_of_serial.customer.district + this.active_log_of_serial.customer.city
          }
        } else if (res.is_receive) {
          this.receive_log_of_serial.push(res);
        }
      })

      let maxDateIndex = 0;
      this.validate_receive_log_of_serial = this.receive_log_of_serial.map((item, index) => {
        if (item.updated_at > this.receive_log_of_serial[maxDateIndex].updated_at) {
          maxDateIndex = index;
        }
        return item;
      });
      this.validate_receive_log_of_serial = this.validate_receive_log_of_serial[maxDateIndex];
      console.log('this.validate_receive_log_of_serial', this.validate_receive_log_of_serial);
      if (this.validate_receive_log_of_serial) {
        // tslint:disable-next-line:max-line-length
        this.validate_receive_log_of_serial.customer.address = this.validate_receive_log_of_serial.customer.address == null ? '' : this.validate_receive_log_of_serial.customer.address;
        if (this.validate_receive_log_of_serial.customer.address) {
          // tslint:disable-next-line:max-line-length
          this.validate_receive_log_of_serial.customer.district = this.validate_receive_log_of_serial.customer.district == null ? '' : ', ' + this.validate_receive_log_of_serial.customer.district;
        } else {
          // tslint:disable-next-line:max-line-length
          this.validate_receive_log_of_serial.customer.district = this.validate_receive_log_of_serial.customer.district == null ? '' : this.validate_receive_log_of_serial.customer.district;
        }
        if (this.validate_receive_log_of_serial.customer.district) {
          // tslint:disable-next-line:max-line-length
          this.validate_receive_log_of_serial.customer.city = this.validate_receive_log_of_serial.customer.city == null ? '' : ', ' + this.validate_receive_log_of_serial.customer.city;
        } else {
          // tslint:disable-next-line:max-line-length
          this.validate_receive_log_of_serial.customer.city = this.validate_receive_log_of_serial.customer.city == null ? '' : this.validate_receive_log_of_serial.customer.city;
        }
        // tslint:disable-next-line:max-line-length
        this.addressCustomer2 = this.validate_receive_log_of_serial.customer.address + this.validate_receive_log_of_serial.customer.district + this.validate_receive_log_of_serial.customer.city
      }
      console.log('this.validate_logs_of_serial', this.receive_log_of_serial, this.active_log_of_serial);
      this.serial_info = data_params_serial;
      this.agency_info = data_params_agency
      console.log('data_params_log', data_params_log)
      console.log('data_params_serial', data_params_serial)
      this.now = moment().format('DD/MM/YYYY');
      document.title = 'Dịch vụ được cung cấp bởi công ty cổ phần iCheck';
      $('#container').css('border', '1px solid #c5b4b4');
      window.onafterprint = function () {
        that.isShowButton = true;
        $('#container').css('border', '1px solid #c5b4b4');
      }
    });
  }

  getProfileBussiness() {
    this.businessService.getDetailBusiness().subscribe((res) => {
      if (res.code == 1) {
        this.inforBussiness = res.data;
      }
    })
  }

  getCity(city_id) {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
      // @ts-ignore
      const result = citiesList.find((val) => {
        return val.id == city_id
      })
      this.inforBussiness_city = result
      console.log('this.cities', this.cities, result);
      console.log('inforBussiness_city.cities', this.inforBussiness_city);
    });
  }

  loadDistrictData(city_id: number, district_id: number) {
    console.log('id', city_id)
    this.addressService
      .getDistrict({city_id: city_id})
      .toPromise()
      .then((res) => {
        const districts = [];
        res.data.districts.forEach((c: any) => {
          console.log('value', city_id)
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
        const result = districts.find((val) => {
          return val.id == district_id
        })
        this.inforBussiness_districts = result
        console.log('inforBussiness_distric.cities', this.inforBussiness_districts);
      });

  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/guarantee/print-guarantee/print-guarantee.component.ts